<mat-accordion>
  @for (n of notifications; track n) {
    <mat-expansion-panel
      class="notifications-expansion-panel"
      hideToggle="true"
      (opened)="ngOnInit()"
      #expPanel
      >
      <mat-expansion-panel-header
        (click)="closeEditMode()"
        [ngClass]="{ 'notification-expanded': expPanel.expanded }"
        >
        <div fxFlex="100">
          <div class="panel-header-text" fxLayout="row">
            <span class="with-icon">
              @if (n.type == 'announcement') {
                <mat-icon
                  aria-label="Announcements"
                  >announcement</mat-icon
                  >
                }
                @if (n.type == 'pm') {
                  <mat-icon aria-label="Messages"
                    >messages</mat-icon
                    >
                  }
                  <span>{{ n.title }}</span></span
                  >
                  <span class="fill-remaining-space"></span>
                  <span class="date-sent" fxShow.gt-sm>{{
                    formatDate(n.createdAt)
                  }}</span>
                </div>
                @if (!expPanel.expanded) {
                  <div
                    class="more-button"
                    fxLayout="row"
                    >
                    <span class="fill-remaining-space"></span>...more...
                  </div>
                }
              </div>
            </mat-expansion-panel-header>
            <ng-template matExpansionPanelContent>
              @if (!editMode && !confirmDelete) {
                <div>
                  <div fxLayout="row wrap" fxLayoutGap.gt-xs="10px">
                    <section fxFlex="100" fxFlex.lt-sm="100" fxLayoutGap="10px">
                      @if (n.type == 'pm') {
                        <div class="to">
                          <span class="to-key">To</span
                            ><span class="to-value">{{
                            getRecipientName(n)
                          }}</span>
                        </div>
                      }
                      <div>
                        <p><span [innerHTML]="n.body"></span></p>
                      </div>
                    </section>
                  </div>
                  @if (n.type == 'announcement') {
                    <mat-grid-list
                      class="announcement-metrics"
                      cols="2"
                      rowHeight="20px"
                      >
                      <mat-grid-tile>
                        <span class="tile-align"
                          ><span class="key">Total Recipients</span>
                          <span class="value">{{
                            n.recipientCount
                          }}</span></span
                          >
                        </mat-grid-tile>
                        <mat-grid-tile>
                          <span class="tile-align"
                            ><span class="key">Read By</span>
                            <span class="value">{{ n.readCount }}</span></span
                            >
                          </mat-grid-tile>
                          <mat-grid-tile>
                            <span class="tile-align"
                              ><span class="key">Display On</span>
                              <span class="value">{{
                                formatDate(n.displayAt)
                              }}</span></span
                              >
                            </mat-grid-tile>
                            <mat-grid-tile>
                              <span class="tile-align"
                                ><span class="key">Expires On</span>
                                <span class="value">{{
                                  formatDate(n.expireAt)
                                }}</span></span
                                >
                              </mat-grid-tile>
                            </mat-grid-list>
                          }
                          @if (n.type == 'announcement') {
                            <mat-action-row
                              fxLayout="row"
                              fxLayoutAlign="end"
                              >
                              <button
                                mat-raised-button
                                (click)="onClickEdit()"
                                class="icon-only"
                                >
                                <mat-icon aria-label="Edit">edit</mat-icon>
                              </button>
                              <button
                                mat-raised-button
                                (click)="onClickDelete()"
                                class="icon-only"
                                >
                                <mat-icon aria-label="Delete">delete</mat-icon>
                              </button>
                            </mat-action-row>
                          }
                        </div>
                      }
                      @if (editMode) {
                        <div>
                          <edit-notification
                            [notification]="n"
                            (save)="editNotification($event)"
                            (cancel)="cancel()"
                          ></edit-notification>
                        </div>
                      }
                      @if (confirmDelete) {
                        <div>
                          <span class="with-icon"
                            ><mat-icon>warning</mat-icon>Delete Announcement?</span
                            >
                            <div>
                              Are you sure you want to delete this Announcement? It will
                              also be removed from your recipient's inbox.
                            </div>
                            <mat-action-row fxLayout="row">
                              <button
                                mat-raised-button
                                color="primary"
                                (click)="onClickDeleteConfirmed(n)"
                                >
                                <span class="with-icon"
                                  ><mat-icon aria-label="Delete">delete</mat-icon
                                  >Delete</span
                                  >
                                </button>
                                <button mat-raised-button (click)="cancel()">
                                  <span class="with-icon"
                                    ><mat-icon aria-label="Cancel">cancel</mat-icon
                                    >Cancel</span
                                    >
                                  </button>
                                </mat-action-row>
                              </div>
                            }
                          </ng-template>
                        </mat-expansion-panel>
                      }
                    </mat-accordion>
